import React from 'react';
import Styles from './styles.module.sass';
import { BASE_PATH, SUB_DIRECTORY } from 'constants/general'
import { NavLink } from 'react-router-dom';
import { decodeStorage } from 'functions/storageBase64';

const HeaderSubMenu = () => {
    const sears_numero_internet = decodeStorage('sears_numero_internet')
    const cardending = decodeStorage('cardending')
    let dataSection

    if(sears_numero_internet && cardending){
        dataSection = [
            {
                title: 'Mi tarjeta',
                url: `${BASE_PATH}${SUB_DIRECTORY}home`,
                target: '_top',
            },
            {
                title: 'Beneficios',
                url: `${BASE_PATH}${SUB_DIRECTORY}beneficios`,
                target: '_top',
            },
            {
                title: 'Pago exprés',
                url: `${BASE_PATH}${SUB_DIRECTORY}pago-express`,
                target: '_top',
            },
            {
                title: 'Autotal inbursa',
                url: 'https://serviciosgfi.inbursa.com:4070/multiplataforma/mvc/others/autotalPublico/init?ca=PUBLICO&pa=P&pro=SEARS#no-back-button',
                target: '_blank',
            }
        ]
    }
    else{
        dataSection = [
            {
                title: 'Mi tarjeta',
                url: `${BASE_PATH}${SUB_DIRECTORY}home`,
                target: '_top',
            },
            {
                title: 'Beneficios',
                url: `${BASE_PATH}${SUB_DIRECTORY}beneficios`,
                target: '_top',
            },
            {
                title: 'Solicitar tarjeta',
                url: `${BASE_PATH}${SUB_DIRECTORY}solicitud-credito-sears`,
                target: '_top',
            },
            {
                title: 'Pago exprés',
                url: `${BASE_PATH}${SUB_DIRECTORY}pago-express`,
                target: '_top',
            },
            {
                title: 'Autotal inbursa',
                url: 'https://serviciosgfi.inbursa.com:4070/multiplataforma/mvc/others/autotalPublico/init?ca=PUBLICO&pa=P&pro=SEARS#no-back-button',
                target: '_blank',
            },
            // {
            //     title: 'Seguros',
            //     url: `${BASE_PATH}${SUB_DIRECTORY}seguros`,
            //     target: '_top',
            // },
        ]
    }


    return (
        <div className={Styles?.subMenu}>
            <ul className={Styles?.contSubMenu}>
                {dataSection.length > 0
                    ? dataSection.map((item, index) => (
                        item?.title != 'Solicitar tarjeta1'
                            ?
                                <li key={index} className={Styles?.liHeaderSubMenu}>
                                    {item?.target === '_blank' 
                                        ?
                                            < a 
                                                href={item.url} 
                                                target={item.target}
                                                className={Styles?.cardMenuItem}
                                            >
                                                {item.title}
                                            </a>
                                        :
                                            <NavLink 
                                                to={item.url}
                                                className={Styles?.cardMenuItem}
                                                activeClassName={`${Styles?.cardMenuItem} ${Styles?.active}`}
                                            >
                                                {item.title}
                                            </NavLink>

                                    }
                                </li>
                            : null
                    ))
                    : null
                }
            </ul>
        </div>
    );
}
export default HeaderSubMenu;